import {
  customerImportResultSchema,
  type CustomerImportRequest,
  type CustomerImportResult,
} from '@tailoring-crm/shared';
import type { ApiClient } from '../api/client.js';

/**
 * The two import calls, taking one payload.
 *
 * The file never leaves the browser: it is parsed here (`readSpreadsheet` from the shared
 * package), mapped here, and what is sent is a grid of strings. So an import is an ordinary
 * JSON request, the API never handles an upload, and the preview and the import send exactly
 * the same body — which is what makes the preview a promise rather than an estimate.
 */

const IMPORT = '/import/customers';

export async function previewCustomerImport(
  client: ApiClient,
  request: CustomerImportRequest,
): Promise<CustomerImportResult> {
  return await client.post(`${IMPORT}/preview`, request, { schema: customerImportResultSchema });
}

export async function importCustomers(
  client: ApiClient,
  request: CustomerImportRequest,
): Promise<CustomerImportResult> {
  return await client.post(IMPORT, request, { schema: customerImportResultSchema });
}
